import { render, staticRenderFns } from "./ApprovalsList.vue?vue&type=template&id=7d696263&scoped=true"
import script from "./ApprovalsList.vue?vue&type=script&lang=js"
export * from "./ApprovalsList.vue?vue&type=script&lang=js"
import style0 from "./ApprovalsList.vue?vue&type=style&index=0&id=7d696263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d696263",
  null
  
)

export default component.exports